<template>
	<div class="sales-history-summary-popup" v-on:keyup.esc="close">
		<div class="customer-heading">
			<span>{{ ship_to_code }}</span>
			<span v-if="ship_to_name"> - {{ ship_to_name }}</span>
		</div>
		<div class="basis">Based on issued invoice totals and returns by Ship To.</div>

		<table class="list_tbl sales-history-table">
			<thead>
				<tr>
					<th>Month</th>
					<th v-for="year in summary.years" :key="year.year">{{ year.year }}</th>
				</tr>
			</thead>
			<tbody v-if="loading">
				<tr>
					<td colspan="4" class="state-cell">Loading sales history...</td>
				</tr>
			</tbody>
			<tbody v-else-if="error_message">
				<tr>
					<td colspan="4" class="state-cell error-cell">
						{{ error_message }}
						<a href="javascript:;" class="retry-link" @click="load">Retry</a>
					</td>
				</tr>
			</tbody>
			<tbody v-else>
				<tr v-for="(month_name, month_index) in month_names" :key="month_name">
					<th class="month-cell">{{ month_name }}</th>
					<td v-for="year in summary.years" :key="year.year" class="amount-cell">
						{{ formatAmount(year.months[month_index].amount) }}
					</td>
				</tr>
				<tr class="total-row">
					<th class="month-cell">Total</th>
					<td v-for="year in summary.years" :key="year.year" class="amount-cell">{{ formatAmount(year.total) }}</td>
				</tr>
			</tbody>
		</table>

		<div v-if="!loading && !error_message && !summary.has_data" class="empty-message">No sales history found for this period.</div>

		<div class="view_bottom_bt">
			<a href="javascript:;" type="button" class="gray_bt" @click="close">Close</a>
		</div>
	</div>
</template>

<script>
import sales_history_summary_popup from './salesHistorySummaryPopupOptions';

export default sales_history_summary_popup;
</script>

<style scoped>
.sales-history-summary-popup {
	width: 680px;
	min-height: 520px;
	padding: 5px;
}

.customer-heading {
	font-size: 14px;
	font-weight: bold;
	margin: 3px 0 2px;
}

.basis {
	color: #666;
	font-size: 11px;
	margin-bottom: 8px;
}

.sales-history-table {
	table-layout: fixed;
}

.sales-history-table th,
.sales-history-table td {
	height: 25px;
}

.sales-history-table thead th:first-child {
	width: 90px;
}

.month-cell {
	text-align: center;
}

.amount-cell {
	padding-right: 8px;
	text-align: right;
}

.total-row th,
.total-row td {
	border-top: 2px solid #777;
	font-weight: bold;
}

.state-cell {
	color: #777;
	padding: 80px 0;
	text-align: center;
}

.error-cell {
	color: #c0392b;
}

.retry-link {
	margin-left: 8px;
}

.empty-message {
	color: #777;
	font-size: 12px;
	margin-top: 8px;
	text-align: center;
}
</style>
